// Shared prompt examples data for SeedePromptBubble and Textarea typewriter effect

export const examplesByTagChinese = {
  auto: [
    {
      id: 1,
      label: 'Art Poster',
      prompt:
        "Design a brand poster with a modern artistic feel, themed 'Infinite Creativity', with a minimalist and high-end style",
    },
    {
      id: 2,
      label: 'Social Media Image',
      prompt:
        'Create an eye-catching social media share image, showcasing new summer drinks, with vibrant and energetic colors',
    },
  ],
  poster: [
    {
      id: 3,
      label: 'Art Exhibition',
      prompt:
        "Create an elegant art exhibition poster, exhibition name 'Contemporary Art Exhibition', duration one month",
    },
    {
      id: 2,
      label: 'Educational Training Institution',
      prompt: `Design a professional brand poster for an educational training institution, divided into two visual layers: "background image" and "foreground text layout".
Text layout style: Modernist style, using clear, sans-serif fonts, grid layout, with a sense of hierarchy.
Maintain good white space, text should not obscure key image areas.
Content as follows (if blank, please supplement and translate to English):
Institution Name: Wisdom Education Training Center
Educational Philosophy: Inspire Potential, Achieve Future - Professional Teachers, Personalized Teaching
Course Schedule: Monday to Sunday 9:00-21:00 / Winter and Summer Camp
Featured Courses: Children's Programming, Creative Arts, English Speaking, Math Thinking, Science Experiments
Contact Information: Inquiry Hotline 400-888-9999 / Address: 8th Floor, City Center Education Building
Color Scheme: Fresh blue tones with white, creating a professional academic atmosphere`,
    },
    {
      id: 1,
      label: 'Fashion Display',
      prompt: `Design an event poster, divided into two visual layers: "background image" and "foreground text layout".
Text layout style: Modernist style, using clear, sans-serif fonts, grid layout, with a sense of hierarchy.
Maintain good white space, text should not obscure key image areas.
Content as follows (if blank, please supplement and translate to English): Event Theme: Event Time: Event Location: Invited Guests (with three photos):`,
    },
  ],
  'social-media': [
    {
      id: 1,
      label: 'Educational Course',
      prompt: `Design an educational course social media image, divided into two visual layers: "background image" and "foreground text layout".

I. Design Style and Layout
• Style Positioning: Simple and clear modern educational style
• Color Scheme: Warm orange tones with white, creating a vibrant learning atmosphere
• Layout: Grid design, maintaining good white space, text does not obscure key image areas

II. Visual Element Requirements
• Creative Painting Elements: Colored brushes, palettes, children's artwork display
• Learning Progress Markers: Progress bars, badges, star rating system
• Decorative Patterns: Geometric shapes embellishment, enhancing visual hierarchy

III. Text Content Structure
Course Name: Art启蒙 Classroom
Course Features: Inspire creative thinking, cultivate artistic literacy
Suitable Age: 3-8 years old children
Course Highlights: Professional art teacher guidance, small class teaching, artwork display
Registration Information: Classes every Saturday and Sunday / Free trial lessons

IV. Technical Requirements
• Size Adaptation: Social media standard size
• Font Specification: Clear and easy-to-read sans-serif fonts, distinct hierarchy
• Quality Requirements: High-definition output, moderate color saturation`,
    },
    {
      id: 2,
      label: 'Fitness Check-in',
      prompt: `Design a fitness check-in social media share image, divided into two visual layers: "background image" and "foreground text layout".

I. Design Style and Layout
• Style Positioning: Dynamic sports style, modern minimalist design
• Color Scheme: Vibrant orange gradient with dark blue, creating a dynamic atmosphere
• Layout: Grid design, maintaining good white space

II. Visual Element Requirements
• Background: Gym environment
• Progress Display: 30-day check-in progress bar or calendar markers

III. Text Content Structure
Challenge Theme: 30-Day Fitness Challenge
Motivational Copy: Every drop of sweat is a transcendence of yourself
Check-in Days: Day 15 / Total 30 days
Exercise Results: Burned 500+ calories / Exercise duration 45 minutes
Encouraging Slogan: Persistence is victory, keep up the good work tomorrow!`,
    },
    {
      id: 3,
      label: 'Reading Notes',
      prompt:
        'Refer to the layout, create a fresh and artistic reading notes sharing image. It needs to have illustrations and text, the content is different reading notes.[SeedeImage##https://static.seedeai.com/asset/d2c7717b-51ac-437f-a3cb-05177a7ba8d8]',
    },
  ],
  infographic: [
    {
      id: 1,
      label: 'Market Trends',
      prompt:
        "Create a data-driven market trend infographic, themed '2025 E-commerce Growth Report'",
    },
    {
      id: 2,
      label: 'Knowledge Popularization',
      prompt:
        "Design an educational themed knowledge popularization chart, content 'Waste Classification Guide'",
    },
    {
      id: 3,
      label: 'Environmental Statistics',
      prompt:
        "Create an environmental themed statistical infographic, title 'Global Carbon Emissions Status'",
    },
  ],
  scrollytelling: [
    {
      id: 1,
      labelKey: 'create.promptExamples.scrollytelling.brandStory',
      label: 'Brand Story Scrollytelling',
      prompt: `Design a scrollytelling long image for a brand story, divided into multiple chapters, each with illustrations and concise text. The overall style is warm and healing.

1. Overall Style
Attribute    Content
Style Positioning    Mountain Aesthetics × Indie Magazine Vibe × Fresh Natural Humanistic Style
Keywords    green lifestyle, summer escape, wild elegance, slow travel, photography zine, rural poetry
Design Character    Light, whitespace, balanced density, minimalism with tactile and textured feel
Applicable Scenarios    Seasonal promotions, countryside travel photography, brand photo exhibition pages, artistic PPTs, nature healing course pages`,
    },
    {
      id: 2,
      labelKey: 'create.promptExamples.scrollytelling.productDetailPage',
      label: 'Product Detail Page',
      prompt: `Create a product detail page for dog food with the following requirements:
1. Use rounded corners, multiple shapes, gradients, blur effects, etc. to enrich the visual effects and information hierarchy of the page, adopting a more advanced and modern design style
2. Mobile-friendly adaptation, fonts should be larger, all text must be at least 32px
3. Optimize layout structure, generated content should fill the poster page size, pay attention to text line spacing, paragraph spacing, page margins, overall aesthetics, can use grid system, avoid large blank areas, prohibit text overlap. [Tip: You can achieve this by changing text size and line spacing. Filling the size is the highest priority]
4. Change the content theme to [dog food], other content can be freely created

Price or promotion information (if any): 618 promotion limited time 50% off

@VeesoMaterial({"url":"https://static.veeso.ai/asset/1f8e1583-66dc-408a-b2ec-a7d71da488b5","width":1024,"height":1024,"aspectRatio":1,"tag":"Logo"})
  `,
    },
    {
      id: 3,
      labelKey: 'create.promptExamples.scrollytelling.publicWelfare',
      label: 'Public Welfare Science',
      prompt:
        'Produce a long image with an environmental public welfare theme, including data visualization, story illustrations, and calls to action. The style is fresh and easy to understand, suitable for social media sharing',
    },
  ],
  presentation: [
    {
      id: 1,
      labelKey: 'create.promptExamples.presentation.projectReport',
      label: 'Project Report',
      prompt: `Generate a modern, fashionable, elegant and premium brand manual (PPT format), including the following 5 core modules:
1. Brand Story: Brand origin, vision, mission, values with concise and powerful copy + high-quality visuals (such as founder story, brand timeline)
2. Visual Identity: Primary/secondary color system (Pantone color codes + application scenarios), Brand LOGO (standard drawing + usage guidelines), Typography system (standard fonts for Chinese and English + combination examples), Graphics/pattern extensions (such as textures, auxiliary graphics)
3. Products & Services: Core product line display (high-precision white background images + scenario application images), Service process/technical advantages (presented in infographics)
4. Brand Tone: Keyword extraction (such as 'minimalist', 'futuristic', 'sustainable'), Visual style reference (mood board: materials/lighting/scenario inspiration images), Brand language guidelines (copy style examples: professional/friendly/pioneering, etc.)
5. Applications: Collaboration case display (co-branded/event posters, etc.)
Design Requirements: Layout: Sufficient whitespace, using asymmetric layout + grid system, Color scheme: Low saturation primary colors (such as premium gray, Morandi colors) + metallic texture accents + detail textures, Typography: Sans-serif fonts (such as Helvetica Neue, Source Han Sans for Chinese)`,
    },
    {
      id: 2,
      label: 'Product Launch',
      prompt: "Create a creative product launch presentation, product 'Smart Home System'",
    },
    {
      id: 3,
      label: 'Financial Report',
      prompt:
        "Create a professional financial report presentation, title '2025 Annual Financial Analysis'",
    },
  ],
  'pull-up-banner': [
    {
      id: 1,
      label: 'Environmental Initiative Pull-up Banner',
      prompt: `Design an environmental protection themed pull-up banner, which must include the following core content:

Main Visual Area:
Display scenes of harmonious coexistence between humans and nature (e.g., forests/oceans/green spaces interacting with humans)
Use green as the main color, with natural element icons

Core Information Layer:
▫️Top Slogan: Highlight keywords such as "Protect the Earth" and "Green Future"
▫️Middle Body:

3 specific action plans for environmental protection (e.g., waste classification/energy saving and emission reduction/tree planting)

Each plan comes with 1 simple icon
▫️Bottom Call to Action:
Emphasize the importance of individual action
Include a scannable QR code for environmental commitment

Design Specifications:
Use a background with recycled material texture
Maintain a text-to-image ratio of 6:4
Important data highlighted in bold green

Visual Requirements:
Avoid using plastic product images
Adopt a flat design style
Ensure the main slogan is clearly recognizable from 3 meters away
Please embody the concept of "Everyone is a guardian of the environment", and through visual design, evoke emotional resonance and behavioral change in the audience.
`,
    },
    {
      id: 2,
      label: 'Product Release',
      prompt: `Design a pull-up banner for the Seede App:
Main Visual Area:
Scene depiction: Show a group of diverse, vibrant young people connecting through mobile phones in urban, natural, or leisure scenes, reflecting the concept of "connecting with real interests"
Main color scheme: Use vibrant blue or gradient neon colors as the main color, with abstract social interaction elements (such as speech bubbles, heartbeat lines, connection nodes, etc. icons)
Core Information Layer:

▫️Top Slogan: Highlight keywords such as "Find like-minded people" and "Start real social interaction", for example:
"Here, meet people like you"

▫️Middle Body:
Reason for recommendation 1: Accurate interest matching (with simple hobby icons, such as music, sports, travel, etc.)
Reason for recommendation 2: Stress-free ice-breaking chat (with speech bubble + emoji icon)
Reason for recommendation 3: Offline local event invitations (with map location + crowd icon)

▫️Bottom Call to Action:
Emphasize "No longer alone, start with an encounter"
Include an App download QR code, labeled "Scan to start your new social circle"`,
    },
    {
      id: 3,
      label: 'Financial Report',
      prompt:
        "Create a simple pull-up banner design, title '2025 Shanghai Auto Show Investment Promotion'",
    },
  ],
  brochure: [
    {
      id: 1,
      label: 'Corporate Brochure',
      prompt: `Design a corporate brochure, 8 pages in total, including cover, company profile, core business, team introduction, success cases, corporate culture, contact information, and back cover.

Design Style: Modern business style, professional and grand
Color Scheme: Corporate blue tones with white and gray, creating a professional and trustworthy atmosphere
Layout: Grid design, maintaining good white space, image-to-text ratio 4:6

Simulated Content:
Company Name: Innovation Technology Co., Ltd.
Company Profile: Established in 2015, focusing on enterprise digital transformation solutions
Core Business: Cloud computing services, AI intelligent applications, enterprise management systems
Team Size: 200+ professional technical personnel
Success Cases: Served 500+ enterprise clients, covering finance, education, retail and other industries
Corporate Culture: Innovation, professionalism, win-win
Contact Information: Phone 400-123-4567 / Email info@company.com / Address: Technology Park, Chaoyang District, Beijing`,
    },
    {
      id: 2,
      label: 'Travel Itinerary',
      prompt: `Create a 7-day Yunnan tour itinerary brochure, including cover, itinerary overview, daily detailed arrangements (attractions, accommodation, dining), travel tips, and booking information.

Design Style: Fresh and natural style, full of travel atmosphere
Color Scheme: Sky blue, natural green with warm tones, creating a relaxed and pleasant vacation feel
Layout: Image-based, with text as supplement, image-to-text ratio 6:4

Simulated Content:
Itinerary Theme: 7-Day In-depth Tour of Yunnan Charm
Departure Date: April 1, 2025
Itinerary Highlights: Dali Ancient City, Lijiang Ancient Town, Jade Dragon Snow Mountain, Lugu Lake, Shangri-La
Accommodation Standard: Four-star hotels + characteristic inns
Dining Arrangement: Breakfast included, characteristic dining (Crossing-the-Bridge Noodles, Roasted Milk Fan, Butter Tea)
Transportation: Tourist bus + partial scenic area sightseeing car
Price: From 3999 RMB/person
Booking Hotline: 400-888-6666`,
    },
    {
      id: 3,
      label: 'Product Manual',
      prompt: `Design a smartwatch product manual, including cover, product features, technical parameters, usage scenarios, accessories introduction, and after-sales service.

Design Style: Tech-modern style, minimalist and fashionable
Color Scheme: Black, silver, tech blue, creating a high-end tech product feel
Layout: Product images prominently displayed, technical parameters clearly arranged, image-to-text ratio 5:5

Simulated Content:
Product Name: SmartWatch Pro X1
Core Features: Health monitoring, sports tracking, smart notifications, long battery life
Technical Parameters:
- Screen: 1.4-inch AMOLED HD display
- Battery Life: 7 days ultra-long battery life
- Water Resistance: 5ATM waterproof rating
- Sensors: Heart rate, blood oxygen, accelerometer, gyroscope
- Connectivity: Bluetooth 5.0, GPS positioning
Usage Scenarios: Sports and fitness, daily commute, business meetings, outdoor exploration
Accessories List: Charging dock, manual, warranty card
After-sales Service: 1-year warranty, 30-day no-reason return, nationwide warranty
Price: 1299 RMB`,
    },
  ],
};

export const examplesByTagEnglish = {
  auto: [
    {
      id: 1,
      label: 'Art Poster',
      prompt:
        "Design a brand poster with a modern art feel, themed 'Infinite Creativity', minimalist and premium style",
    },
    {
      id: 2,
      label: 'Social Media',
      prompt:
        'Create an eye-catching social media share image showcasing new summer drinks, vibrant and energetic colors',
    },
  ],
  poster: [
    {
      id: 3,
      label: 'Art Exhibition',
      prompt:
        "Create an elegant art exhibition poster, exhibition name 'Contemporary Art Gallery', duration one month",
    },
    {
      id: 1,
      label: 'Tech Conference',
      prompt:
        "Create a modern minimalist tech conference poster, title '2025 AI Design Summit', location Beijing",
    },
    {
      id: 2,
      label: 'Music Festival',
      prompt:
        "Design a vibrant music festival promotional poster, theme 'Spring Music Festival', date March 15th",
    },
  ],
  'social-media': [
    {
      id: 1,
      label: 'Food Sharing',
      prompt: "Design a warm food sharing social media image, theme 'Home Recipe Sharing'",
    },
    {
      id: 2,
      label: 'Business Event',
      prompt:
        "Create a professional business event promotional image, event name 'Entrepreneurs Summit 2025'",
    },
    {
      id: 3,
      label: 'Product Launch',
      prompt:
        "Create a stylish product launch social media image, new product 'Spring Limited Edition Perfume'",
    },
  ],
  scrollytelling: [
    {
      id: 1,
      labelKey: 'create.promptExamples.scrollytelling.brandStory',
      label: 'Brand Story',
      prompt: `Design a scrollytelling long image for a brand story, divided into multiple chapters, each with illustrations and concise text. The overall style is warm and healing.

1. Overall Style
Attribute    Content
Style Positioning    Mountain Aesthetics × Indie Magazine Vibe × Fresh Natural Humanistic Style
Keywords    green lifestyle, summer escape, wild elegance, slow travel, photography zine, rural poetry
Design Character    Light, whitespace, balanced density, minimalism with tactile and textured feel
Applicable Scenarios    Seasonal promotions, countryside travel photography, brand photo exhibition pages, artistic PPTs, nature healing course pages`,
    },
    {
      id: 2,
      label: 'Product Demo',
      prompt:
        'Create a long image for product feature demonstration, using step-by-step animation and visual guidance to highlight product features. Bright colors, suitable for online promotion.',
    },
    {
      id: 3,
      label: 'Public Welfare',
      prompt:
        'Produce a long image with an environmental public welfare theme, including data visualization, story illustrations, and calls to action. The style is fresh and easy to understand, suitable for social media sharing.',
    },
  ],
  infographic: [
    {
      id: 1,
      label: 'Market Trends',
      prompt:
        "Create a data-driven market trend infographic, theme '2025 E-commerce Growth Report'",
    },
    {
      id: 2,
      label: 'Educational Content',
      prompt: "Design an educational knowledge infographic, content 'Waste Sorting Guide'",
    },
    {
      id: 3,
      label: 'Environmental Stats',
      prompt:
        "Create an environmental statistics infographic, title 'Global Carbon Emissions Status'",
    },
  ],
  presentation: [
    {
      id: 1,
      label: 'Project Report',
      prompt: "Design a business-style project report PPT cover, project name 'Q4 Sales Summary'",
    },
    {
      id: 2,
      label: 'Product Launch',
      prompt: "Create a creative product launch presentation, product 'Smart Home System'",
    },
    {
      id: 3,
      label: 'Financial Report',
      prompt:
        "Create a professional financial report presentation, title '2025 Annual Financial Analysis'",
    },
  ],
  brochure: [
    {
      id: 1,
      label: 'Corporate Brochure',
      prompt: `Design a corporate brochure with 8 pages, including cover, company introduction, core business, team introduction, success cases, corporate culture, contact information, and back cover.

Design Style: Modern business style, professional and elegant
Color Scheme: Corporate blue with white and gray, creating a professional and trustworthy atmosphere
Layout: Grid-based design, maintaining good white space, image-to-text ratio 4:6`,
    },
    {
      id: 2,
      label: 'Travel Itinerary',
      prompt: `Create a 7-day Yunnan tour itinerary brochure, including cover, itinerary overview, daily detailed arrangements (attractions, accommodation, dining), travel tips, and booking information.

Design Style: Fresh and natural style, full of travel atmosphere
Color Scheme: Sky blue, natural green with warm tones, creating a relaxed and pleasant vacation feel
Layout: Image-focused with supporting text, image-to-text ratio 6:4`,
    },
    {
      id: 3,
      label: 'Product Manual',
      prompt: `Design a smartwatch product manual, including cover, product features, technical specifications, usage scenarios, accessories introduction, and after-sales service.

Design Style: Tech-modern style, minimalist and fashionable
Color Scheme: Black, silver, tech blue, creating a premium tech product feel
Layout: Product images prominently displayed, technical specifications clearly arranged, image-to-text ratio 5:5`,
    },
  ],
};

export const examplesByTagJapanese = {
  auto: [
    {
      id: 1,
      label: 'Art Poster',
      prompt:
        'Design a sophisticated brand poster like modern art. The theme is "Infinite Creativity", with a minimalist and premium style.',
    },
    {
      id: 2,
      label: 'SNS Image',
      prompt:
        'Create an eye-catching SNS share image. Introduce new summer drinks with vibrant and energetic colors.',
    },
  ],
  poster: [
    {
      id: 3,
      label: 'Art Exhibition',
      prompt:
        'Create an elegant art exhibition poster. The exhibition name is "Contemporary Art Gallery", and the duration is one month.',
    },
    {
      id: 1,
      label: 'Tech Conference',
      prompt:
        'Create a modern and minimalist tech conference poster. The title is "2025 AI Design Summit", and the location is Beijing.',
    },
    {
      id: 2,
      label: 'Music Festival',
      prompt:
        '活気あふれる音楽フェスティバルのプロモーションポスターをデザインしてください。テーマは「春の音楽祭」、日付は3月15日です。',
    },
  ],
  'social-media': [
    {
      id: 1,
      label: '料理シェア',
      prompt:
        '温かみのある料理シェア用のSNS画像をデザインしてください。テーマは「おうちレシピシェア」です。',
    },
    {
      id: 2,
      label: 'ビジネスイベント',
      prompt:
        'プロフェッショナルなビジネスイベントのプロモーション画像を作成してください。イベント名は「アントレプレナーサミット2025」です。',
    },
    {
      id: 3,
      label: '新商品発表',
      prompt:
        'スタイリッシュな新商品発表用SNS画像を作成してください。新商品は「春限定パフューム」です。',
    },
  ],
  scrollytelling: [
    {
      id: 1,
      label: 'ブランドストーリー',
      prompt: `ブランドストーリーのためのスクロリーテリング長尺画像をデザインしてください。複数の章に分かれ、それぞれにイラストと簡潔なテキストを含みます。全体のスタイルは温かく癒し系です。

1. 全体スタイル
属性    内容
スタイルポジショニング    山岳美学 × インディーマガジン風 × フレッシュでナチュラルなヒューマニスティックスタイル
キーワード    グリーンライフスタイル、夏の避暑、野生のエレガンス、スロートラベル、フォトジン、田園詩
デザイン特徴    軽やか、余白、密度のバランス、ミニマリズムと触感・質感
適用シーン    季節プロモーション、田舎旅行写真、ブランド写真展ページ、アート系PPT、自然癒し系コースページ`,
    },
    {
      id: 2,
      label: '製品デモページ',
      prompt:
        '製品機能デモ用の長尺画像を作成してください。ステップごとのアニメーションとビジュアルガイドで特徴を強調します。明るい色使いで、オンラインプロモーションに適しています。',
    },
    {
      id: 3,
      label: '公益サイエンス',
      prompt:
        '環境保護をテーマにした公益サイエンス長尺画像を制作してください。データビジュアライゼーション、ストーリーイラスト、アクション呼びかけを含みます。スタイルはフレッシュで分かりやすく、SNSシェアに最適です。',
    },
  ],
  infographic: [
    {
      id: 1,
      label: '市場トレンド',
      prompt:
        'データ駆動型の市場トレンドインフォグラフィックを作成してください。テーマは「2025年EC成長レポート」です。',
    },
    {
      id: 2,
      label: '教育コンテンツ',
      prompt:
        '教育知識のインフォグラフィックをデザインしてください。内容は「ごみ分別ガイド」です。',
    },
    {
      id: 3,
      label: '環境統計',
      prompt:
        '環境統計のインフォグラフィックを作成してください。タイトルは「世界の二酸化炭素排出状況」です。',
    },
  ],
  presentation: [
    {
      id: 1,
      label: 'プロジェクト報告書',
      prompt:
        'ビジネススタイルのプロジェクト報告書PPTカバーをデザインしてください。プロジェクト名は「Q4売上サマリー」です。',
    },
    {
      id: 2,
      label: '新商品発表',
      prompt:
        'クリエイティブな新商品発表プレゼンテーションを作成してください。商品は「スマートホームシステム」です。',
    },
    {
      id: 3,
      label: '財務報告書',
      prompt:
        'プロフェッショナルな財務報告書プレゼンテーションを作成してください。タイトルは「2025年年間財務分析」です。',
    },
  ],
};

/**
 * Get examples by scene tag and locale
 * @param {string} tag - Scene tag (e.g., 'poster', 'social-media')
 * @param {string} locale - Locale code ('zh', 'en', 'ja')
 * @returns {Array} Array of examples for the given tag and locale
 */
export function getExamplesByTag(tag, locale) {
  let examplesByTag;
  if (locale === 'zh') {
    examplesByTag = examplesByTagChinese;
  } else if (locale === 'ja') {
    examplesByTag = examplesByTagJapanese;
  } else {
    examplesByTag = examplesByTagEnglish;
  }
  return examplesByTag[tag] || [];
}

/**
 * Get labels only by scene tag and locale
 * @param {string} tag - Scene tag (e.g., 'poster', 'social-media')
 * @param {string} locale - Locale code ('zh', 'en', 'ja')
 * @returns {Array<string>} Array of labels for the given tag and locale
 */
export function getLabelsByTag(tag, locale) {
  const examples = getExamplesByTag(tag, locale);
  return examples.map((e) => e.label);
}
